/**
 * Utilities for working with URLs.
 * All helpers are pure and do not mutate inputs.
 */

/**
 * Checks whether a string looks like an HTTP(S) URL.
 * Accepts values with or without protocol as long as they resemble domains.
 */
export const isProbablyUrl = (value: string | null | undefined): boolean => {
  if (!value) return false;
  const trimmed = value.trim();
  if (trimmed.length === 0) return false;
  if (/\s/.test(trimmed)) return false;

  // Allow with or without protocol, optional port and path
  const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(?::\d+)?(\/\S*)?$/i;
  return urlPattern.test(trimmed);
};

/**
 * Ensures a URL has protocol. Defaults to https when missing.
 */
export const ensureUrlWithProtocol = (value: string): string => {
  const trimmed = value.trim();
  return /^(?:https?:)?\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};
